import React, { useState } from 'react';

export const ShowMoreItemsHeader = ({ items, maxShowNumber }) => {
  const [isShowMore, setIsShowMore] = useState(false);
  return (
    <div style={isShowMore ? { maxWidth: '220px' } : {}}>
      {!isShowMore
        ? items.map((item, index) => {
            return (
              index < maxShowNumber && (
                <strong key={item.name}>
                  <span className={`${item.archived ? 'text-muted' : ''}`}>
                    {item.name}
                  </span>
                  {items.length !== index + 1 ? ',' : ''}
                  &nbsp;
                </strong>
              )
            );
          })
        : items.map((item, index) => (
            <strong key={item.name}>
              <span className={`${item.archived ? 'text-muted' : ''}`}>
                {item.name}
              </span>
              {items.length !== index + 1 ? ',' : ''}
              &nbsp;
            </strong>
          ))}
      {!isShowMore && items.length > maxShowNumber ? (
        <button
          type="button"
          className="btn-link"
          onClick={() => setIsShowMore(true)}
        >
          +{items.length - maxShowNumber}
        </button>
      ) : null}
    </div>
  );
};
